import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import {
  STATUS_ICON_LOADING,
  STATE_ICON_RUN,
  STATUS_ICON_CLOCK,
  STATE_ICON_STOP,
  STATUS_ICON_TIMES_O,
} from '@/common/utils/statuses';

export const KEY_LIFETIME_MIN = 60;

export const VPN_STATUS_ACTIVE = 'ACTIVE';
export const VPN_STATUS_DOWN = 'DOWN';
export const VPN_STATUS_BUILD = 'BUILD';
export const VPN_STATUS_ERROR = 'ERROR';
export const VPN_STATUS_PENDING_CREATE = 'PENDING_CREATE';
export const VPN_STATUS_PENDING_UPDATE = 'PENDING_UPDATE';
export const VPN_STATUS_PENDING_DELETE = 'PENDING_DELETE';

export const VPN_STATUSES = [
  VPN_STATUS_ACTIVE,
  VPN_STATUS_DOWN,
  // VPN_STATUS_BUILD,
  // VPN_STATUS_ERROR,
  VPN_STATUS_PENDING_CREATE,
  // VPN_STATUS_PENDING_UPDATE,
  // VPN_STATUS_PENDING_DELETE,
];

export const VPN_STATUSES_TITLES = computedLocale(() => ({
  [VPN_STATUS_ACTIVE]: i18n.t('Active'),
  [VPN_STATUS_DOWN]: i18n.t('Down'),
  [VPN_STATUS_BUILD]: i18n.t('Creating...'),
  [VPN_STATUS_ERROR]: i18n.t('Error'),
  [VPN_STATUS_PENDING_CREATE]: i18n.t('Pending creation'),
  [VPN_STATUS_PENDING_UPDATE]: i18n.t('Pending update'),
  [VPN_STATUS_PENDING_DELETE]: i18n.t('Pending deletion'),
}));

export const VPN_STATUSES_ICON_MAP = {
  [VPN_STATUS_ACTIVE]: STATE_ICON_RUN,
  [VPN_STATUS_DOWN]: STATE_ICON_STOP,
  [VPN_STATUS_BUILD]: STATUS_ICON_LOADING,
  [VPN_STATUS_ERROR]: STATUS_ICON_TIMES_O,
  [VPN_STATUS_PENDING_CREATE]: STATUS_ICON_CLOCK,
  [VPN_STATUS_PENDING_UPDATE]: STATUS_ICON_CLOCK,
  [VPN_STATUS_PENDING_DELETE]: STATUS_ICON_CLOCK,
};

export const AUTH_ALGORITHM_SHA1 = 'sha1';
export const AUTH_ALGORITHM_SHA256 = 'sha256';
export const AUTH_ALGORITHM_SHA384 = 'sha384';
export const AUTH_ALGORITHM_SHA512 = 'sha512';

export const AUTH_ALGORITHM_TITLES = computedLocale(() => ({
  [AUTH_ALGORITHM_SHA1]: i18n.t('SHA-1'),
  [AUTH_ALGORITHM_SHA256]: i18n.t('SHA-256'),
  [AUTH_ALGORITHM_SHA384]: i18n.t('SHA-384'),
  [AUTH_ALGORITHM_SHA512]: i18n.t('SHA-512')
}));

export const AUTH_ALGORITHMS = [
  AUTH_ALGORITHM_SHA1,
  AUTH_ALGORITHM_SHA256,
  AUTH_ALGORITHM_SHA384,
  AUTH_ALGORITHM_SHA512
];

export const ENCRYPTION_ALGORITHM_3DES = '3des';
export const ENCRYPTION_ALGORITHM_AES_128 = 'aes-128';
export const ENCRYPTION_ALGORITHM_AES_192 = 'aes-192';
export const ENCRYPTION_ALGORITHM_AES_256 = 'aes-256';

export const ENCRYPTION_ALGORITHMS_TITLES = computedLocale(() => ({
  [ENCRYPTION_ALGORITHM_3DES]: i18n.t('3DES'),
  [ENCRYPTION_ALGORITHM_AES_128]: i18n.t('AES-128'),
  [ENCRYPTION_ALGORITHM_AES_192]: i18n.t('AES-192'),
  [ENCRYPTION_ALGORITHM_AES_256]: i18n.t('AES-256')
}));

export const ENCRYPTION_ALGORITHMS = [
  ENCRYPTION_ALGORITHM_3DES,
  ENCRYPTION_ALGORITHM_AES_128,
  ENCRYPTION_ALGORITHM_AES_192,
  ENCRYPTION_ALGORITHM_AES_256
];

export const IKE_VERSION_V1 = 'v1';
export const IKE_VERSION_V2 = 'v2';

export const IKE_VERSIONS = [IKE_VERSION_V1, IKE_VERSION_V2];

export const PFS_GROUP_2 = 'group2';
export const PFS_GROUP_5 = 'group5';
export const PFS_GROUP_14 = 'group14';

export const PFS_GROUPS = [
  PFS_GROUP_2,
  PFS_GROUP_5,
  PFS_GROUP_14
];

export const INITIATOR_BI_DIRECTIONAL = 'bi-directional';
export const INITIATOR_RESPONSE_ONLY = 'response-only';

export const INITIATORS_TITLES = computedLocale(() => ({
  [INITIATOR_BI_DIRECTIONAL]: i18n.t('Bi-directional'),
  [INITIATOR_RESPONSE_ONLY]: i18n.t('Response-only'),
}));

export const INITIATORS = [INITIATOR_BI_DIRECTIONAL];

export const DPD_ACTION_HOLD = 'hold';
export const DPD_ACTION_CLEAR = 'clear';
export const DPD_ACTION_RESTART = 'restart';
export const DPD_ACTION_DISABLED = 'disabled';

export const DPD_ACTIONS_TITLES = computedLocale(() => ({
  [DPD_ACTION_HOLD]: i18n.t('Hold'),
  [DPD_ACTION_CLEAR]: i18n.t('Clear'),
  [DPD_ACTION_RESTART]: i18n.t('Restart'),
  [DPD_ACTION_DISABLED]: i18n.t('Disabled'),
}));
export const DPD_ACTIONS = [
  DPD_ACTION_HOLD,
  DPD_ACTION_CLEAR,
  DPD_ACTION_RESTART,
  DPD_ACTION_DISABLED
];
